import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DeptListing } from '../shared/models/dept-listing';

@Injectable({
  providedIn: 'root'
})
export class DeptService {

	httpOptions = {
		headers: new HttpHeaders ({ 'Content-Type': 'application/json'})
	}
	
  	constructor(private http: HttpClient) { }
  
  
	public getAllDept(filter): Observable<DeptListing[]> { 
			
		return this.http.get<DeptListing[]>('searchdeptbyname?name='+filter)
			.pipe(catchError(this.handleError<any>(`searchdeptbyname`))

		);
				
	}
	

	public getDeptDetail(filter): Observable<DeptListing[]> { 
		
		
		return this.http.get<DeptListing[]>('searchdeptbyoid?oid='+filter )
			.pipe(catchError(this.handleError<any>(`searchdeptbyoid`)));

         return this.http.get<DeptListing[]>('searchdeptbyoid?oid='+filter )
            .pipe(catchError(this.handleError<any>(`searchdeptbyoid`))

 
		);
				
	}
	
	private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
    
    
  }
}
